import {Sprite} from 'pixi.js';
import {KeypadView, KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad';
import {WinMeterViewMobileLandscape} from '@gongxigames/framework/slot/modules/winmeter/index';

export class WinMeterViewMobilePortrait extends WinMeterViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('WinMeterViewMobilePortrait');

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobilePortrait.NAME];
    }
}
